/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Prop} from 'vue-property-decorator';
import {Action} from 'vuex-class';
import Loading from '@/components/Loading/index.vue';
import PageHeader from '@/components/PageHeader/index.vue';
import {LoadingState, LoadingStateInterface} from '@/components/Loading/types';
import DynamicEula from '@/mixins/DynamicComponent/Eula';
import {mixins} from 'vue-class-component';

const namespaceSession: string = 'userSessionModule';

/**
 * Terms view (component).
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'v-terms',
    components: {
        'c-loading': Loading,
        'c-page-header': PageHeader,
    },
})
export default class Terms extends mixins(DynamicEula) {
    @Action('readTerms', {namespace: namespaceSession}) public readTerms: any;
    @Action('softLogout', {namespace: namespaceSession}) public softLogout: any;
    @Prop(Boolean) public eula!: boolean;

    public state: LoadingStateInterface = new LoadingState(false, false);

    /**
     * Update the status of the terms and conditions read state.
     *
     * @returns {Promise<void>}
     */
    public async readTermsAction(): Promise<void> {
        try {
            this.state.loading = true;
            await this.readTerms();
            this.$router.push({name: 'item'});
            this.state.complete();
        } catch (error) {
            // @todo deal with error
            this.state.failed();
        }
    }

    /**
     * Disagree action.
     *
     * This performs a soft logout to prevent duplication of EULA errors.
     */
    public disagree(): void {
        this.softLogout();
        this.$router.push({name: 'login'});
    }
}
